import { render, staticRenderFns } from "./EventSingup.vue?vue&type=template&id=76bdd594&"
import script from "./EventSingup.vue?vue&type=script&lang=ts&"
export * from "./EventSingup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports